var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.nameClass},[_c('use',{attrs:{"xlink:href":_vm.hrefName,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }